import _ from 'lodash';
import moment from 'moment';
import {
  Firebase,
  ifCallbackIsFunction,
  unwrapDoc, goalValueIsSet,
  unwrapDocs,
  logAndDispatchErrorForAction,
  withoutId,
  getCurrentTimestamp,
  accountId,
  organizationId,
  isProduction,
  omitDeleted,
  addKeysAsIds
} from './../util';
import {
  getCurrentQuarterString,
  isInEvaluationPeriodForCurrentQuarter,
  getNextQuarterString,
} from './../util/quarters';
import { OrganizationRef, SprintHistoryRef, CurrentSprintsRef } from './../util/refs';

import {
  FETCH_SPRINT_DATA,
  FETCH_SPRINT_DATA_SUCCESS,
  FETCH_SPRINT_DATA_ERROR,

  SAVE_SPRINT,
  SAVE_SPRINT_SUCCESS,
  SAVE_SPRINT_ERROR,

  SAVE_SPRINT_OPTIONS,
  SAVE_SPRINT_OPTIONS_SUCCESS,
  SAVE_SPRINT_OPTIONS_ERROR,

  FETCH_SPRINT_HISTORY,
  FETCH_SPRINT_HISTORY_SUCCESS,
  FETCH_SPRINT_HISTORY_ERROR,

} from './types';

function resetSprintData(sprint, organizationSprintGoals){

  let resetSprint = {...sprint};

  //next week action items become this week's, and delete what was added for "next week"
  resetSprint.thisWeekActionItems = resetSprint.nextWeekActionItems;
  resetSprint.nextWeekActionItems = '';

  delete resetSprint.submittedOn;

  delete resetSprint.startDate;
  delete resetSprint.endDate;

  delete resetSprint.userRating;
  delete resetSprint.managerRating;

  resetSprint.status = 'editing';

  //if we're resetting the last sprint of the quarter, then set sprint status to paused
  //which will be unlocked when manager setups up new sprint
  if(isInEvaluationPeriodForCurrentQuarter()){
    resetSprint.status = 'paused';
    resetSprint.period = getNextQuarterString(); //get next quarter
  }

  //TODO figure out what this needs to be!
  // if(isInEvaluationPeriodForCurrentQuarter()){
  //   //we're in evaluation period, so this sprint submission is the last one of the quarter...
  //
  // }
  //
  // //update period if since we might be resetting the sprint after quarter end
  // resetSprint.period = getCurrentQuarterString();

  resetSprint.lastModified = getCurrentTimestamp();

  const activeSprintGoals = _.filter(organizationSprintGoals, goal => {
    return !goal.inactive;
  });

  //remove goals that don't have an active sprint goal set at the organization level
  _.remove(resetSprint.goals, goal => {
    const foundMatch = _.find(activeSprintGoals, activeSprintGoal => {
      return activeSprintGoal.id === goal.id;
    });

    return !foundMatch;
  });
  // console.log('updated goals: ', resetSprint.goals);

  _.each(resetSprint.goals, goal => {
    if(goal.goalMeta){
      if(goal.goalMeta.worstCasePrediction){
        delete goal.goalMeta.worstCasePrediction;
      }
      if(goal.goalMeta.bestCasePrediction){
        delete goal.goalMeta.bestCasePrediction;
      }
      if(goal.goalMeta.practicedHow){
        delete goal.goalMeta.practicedHow;
      }
      if(goal.goalMeta.appliedHow){
        delete goal.goalMeta.appliedHow;
      }
      if(goal.goalMeta.improvedHow){
        delete goal.goalMeta.improvedHow;
      }
    }
    if(goalValueIsSet(goal.goalValue)){
      delete goal.goalValue;
    }
  });

  return resetSprint;
}

export function finalizeSprint(sprint, callback){
  console.log('submitting sprint for review: ', sprint);

  const ThisSprintRef = CurrentSprintsRef().doc(sprint._id);

  //make a copy for saving to history
  let sprintForHistory = {
    userId: sprint._id,
    reviewedBy: accountId(),
    reviewedOn: getCurrentTimestamp(),
    submittedOn: sprint.submittedOn,
    startDate: sprint.startDate,
    endDate: sprint.endDate,
    thisWeekActionItems: sprint.thisWeekActionItems || '',
    nextWeekActionItems: sprint.nextWeekActionItems || '',
    userRating: sprint.userRating,
    managerRating: sprint.managerRating,
    goals: sprint.goals,
    period: sprint.period,
  }

  return dispatch => {
    SprintHistoryRef().add(sprintForHistory).then(docRef => {
      console.log('sprint added to history at ', docRef.id);

      const historicSprintId = docRef.id;

      OrganizationRef().get().then(organizationDoc => {
        const organization = unwrapDoc(organizationDoc);

        // console.log('found org: ', organization);
        // console.log('org goals: ', organization.sprintGoals);

        const resetSprint = resetSprintData(sprint, organization.sprintGoals);

        ThisSprintRef.set(resetSprint).then(() => {
          // console.log('sprint reset successfully.');

          dispatch({
            type: SAVE_SPRINT_SUCCESS,
            payload: resetSprint
          });

          ifCallbackIsFunction(callback, historicSprintId);

        }).catch(err => { logAndDispatchErrorForAction(`Resetting sprint after saving to history ${sprint._id}`, err, dispatch, SAVE_SPRINT_ERROR, callback) });;

      });

    }).catch(err => { logAndDispatchErrorForAction(`Adding sprint to sprint history ${sprint._id}`, err, dispatch, SAVE_SPRINT_ERROR, callback) });
  }
}

export function submitSprintForReview(sprint, callback){
  console.log('submitting sprint for review: ', sprint);

  const ThisSprintRef = CurrentSprintsRef().doc(sprint._id);

  sprint.lastModified = getCurrentTimestamp();
  sprint.status = 'submitted';
  sprint.submittedOn = getCurrentTimestamp();

  return dispatch => {
    dispatch({
      type: SAVE_SPRINT,
      payload: sprint,
    });

    ThisSprintRef.update(sprint).then(() => {
      ThisSprintRef.get().then(doc => {

        const updatedSprint = unwrapDoc(doc);

        dispatch({
          type: SAVE_SPRINT_SUCCESS,
          payload: updatedSprint
        });

        ifCallbackIsFunction(callback);
      });
    }).catch(err => { logAndDispatchErrorForAction(`Submit sprint for review ${sprint._id}`, err, dispatch, SAVE_SPRINT_ERROR, callback); });
  }
}

export function updateCurrentSprintGoalsForEmployee(employeeId, sprint, callback){
  console.log('updating sprint goals for user: ', employeeId, sprint);

  const ThisSprintRef = CurrentSprintsRef().doc(employeeId);

  sprint.lastModified = getCurrentTimestamp();
  sprint.status = 'editing';

  if(!sprint.period){
    sprint.period = getCurrentQuarterString();
  }

  return dispatch => {

    dispatch({
      type: SAVE_SPRINT,
      payload: sprint,
    });

    CurrentSprintsRef().doc(employeeId).set(sprint).then(() => {

      //if sprint doesn't have ._id set...
      if(!sprint._id){
        sprint._id = employeeId;
      }

      dispatch({
        type: SAVE_SPRINT_SUCCESS,
        payload: sprint
      });

      ifCallbackIsFunction(callback);

    }).catch(err => { logAndDispatchErrorForAction(`Save Current Sprint for user ${employeeId}`, err, dispatch, SAVE_SPRINT_ERROR); });
  }
}

export function saveCurrentSprintForEmployee(employeeId, sprint, callback){
  console.log('updating sprint for user: ', employeeId, sprint);

  const ThisSprintRef = CurrentSprintsRef().doc(employeeId);

  sprint.lastModified = getCurrentTimestamp();

  return dispatch => {

    dispatch({
      type: SAVE_SPRINT,
      payload: sprint,
    });

    CurrentSprintsRef().doc(employeeId).set(sprint).then(() => {

      //if sprint doesn't have ._id set...
      if(!sprint._id){
        sprint._id = employeeId;
      }

      dispatch({
        type: SAVE_SPRINT_SUCCESS,
        payload: sprint
      });

      ifCallbackIsFunction(callback, sprint);

    }).catch(err => { logAndDispatchErrorForAction(`Save Current Sprint for user ${employeeId}`, err, dispatch, SAVE_SPRINT_ERROR); });
  }
}

// export function fetchCurrentSprintsForTeam(employeeIds, callback){
//   console.log('fetching sprint data for users: ', employeeIds);
//
//   const ThisSprintRef = CurrentSprintsRef().doc(employeeId);
//
//   return dispatch => {
//
//     dispatch({
//       type: FETCH_SPRINT_DATA,
//     });
//
//     ThisSprintRef.get().then(doc => {
//
//       const currentSprint = unwrapDoc(doc);
//
//       dispatch({
//         type: FETCH_SPRINT_DATA_SUCCESS,
//         payload: currentSprint || {}
//       });
//
//       ifCallbackIsFunction(callback);
//
//     }).catch(err => { logAndDispatchErrorForAction(`Fetch Current Sprint for user ${employeeId}`, err, dispatch, FETCH_SPRINT_DATA_ERROR, callback); });
//   }
// }

export function fetchCurrentSprintForEmployee(employeeId, callback){
  console.log('fetching sprint data for user: ', employeeId);

  const ThisSprintRef = CurrentSprintsRef().doc(employeeId);

  return dispatch => {

    dispatch({
      type: FETCH_SPRINT_DATA,
    });

    ThisSprintRef.get().then(doc => {

      const currentSprint = unwrapDoc(doc);

      dispatch({
        type: FETCH_SPRINT_DATA_SUCCESS,
        payload: currentSprint || {}
      });

      ifCallbackIsFunction(callback, currentSprint);

    }).catch(err => { logAndDispatchErrorForAction(`Fetch Current Sprint for user ${employeeId}`, err, dispatch, FETCH_SPRINT_DATA_ERROR, callback); });
  }
}

export function fetchSprintHistoryForEmployee(employeeId, callback){
  console.log('fetching sprint history for user: ', employeeId);

  return dispatch => {

    dispatch({
      type: FETCH_SPRINT_HISTORY,
    });

    console.log('getting history...');

    SprintHistoryRef().where('userId', '==', employeeId).orderBy('endDate', 'desc').onSnapshot(docs => {

      console.log('sprint history fetched for employee!');

      const sprintHistory = unwrapDocs(docs);

      dispatch({
        type: FETCH_SPRINT_HISTORY_SUCCESS,
        payload: sprintHistory || []
      });

      ifCallbackIsFunction(callback, sprintHistory);

    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/sprint.js